import { NotifyEmails } from 'store/declarations/declaration';
import {
    amendIrelandEntrySummaryDeclaration,
    amendIrelandExportDeclaration,
    amendIrelandImportDeclaration,
    createIrelandArrivalAtExitDeclaration,
    createIcs2EnsDeclaration,
    updateIcs2EnsDeclaration,
    amendIcs2EnsDeclaration,
    createIrelandENSDeclaration,
    createIrelandEtdDeclaration,
    createIrelandExportDeclaration,
    createIrelandH7ImportDeclaration,
    createIrelandImportDeclaration,
    createCdsDeclaration,
    createIrelandTSDDeclaration,
    duplicateDeclaration,
    getDeclaration,
    getDeclarationDocuments,
    getDeclarationHistory,
    invalidateDeclaration,
    invalidateNctsDeclaration,
    invalidateUkNctsDeclaration,
    invalidateExportDeclaration,
    submitDeclaration,
    submitIrelandImportDocuments,
    submitImportPresentationNotification,
    toggleCoreTemplateStatus,
    updateIrelandArrivalAtExitDeclaration,
    updateIrelandENSDeclaration,
    updateIrelandEtdDeclaration,
    updateIrelandExportDeclaration,
    updateIrelandH7ImportDeclaration,
    updateIrelandImportDeclaration,
    updateIrelandTSDDeclaration,
    createIrelandH1ImportDeclarationWithFile,
    createIrelandH7ImportDeclarationsWithBulkUpload,
    getTemplate,
    cancelCdsDeclaration,
    cancelAmendmentIrelandExportDeclaration,
    createGvmsRecord,
    updateGvmsRecord,
    updateCdsDeclaration,
    cancelAmendmentGmrRecord,
    amendGmrRecord,
    createPbnRecord,
    updatePbnRecord,
    createIrelandNctsDeclaration,
    createUkNctsDeclaration,
    updateNctsDeclaration,
    updateUkNctsDeclaration,
} from './client';
import { Declaration, DeclarationDocumentsFilterFields } from './declaration';
import { ArrivalAtExitDeclarationPayload } from './ireland/arrival-at-exit-declaration';
import {
    ElectronicTransportDocument,
    ElectronicTransportDocumentPayload,
} from './ireland/electronic-transport-document';
import { IrelandEntrySummaryDeclarationPayload } from './ireland/entry-summary-declaration';
import { IrelandExportDeclarationPayload } from './ireland/export-declaration';
import { IrelandH7ImportDeclarationPayload } from './ireland/h7-import-declaration';
import { IrelandImportDeclarationPayload } from './ireland/import-declaration';
import { NctsDeclaration } from './ireland/ncts-declaration';
import { IrelandPbnRecord } from './ireland/pbn-declaration';
import { IrelandTemporaryStorageDeclarationPayload } from './ireland/temporary-storage-declaration';
import { CdsDeclarationPayload } from './uk/cds-declaration';
import { UkGvmsRecord } from './uk/gvms-declaration';

export const doCreateIrelandImportDeclaration: Function =
    (customerId: string, declaration: IrelandImportDeclarationPayload, templateId?: string) =>
    async (dispatch: Function) => {
        dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_REQUEST' });

        try {
            const payload = await createIrelandImportDeclaration(customerId, declaration, templateId);
            dispatch({
                type: 'CREATE_IRELAND_IMPORT_DECLARATION_SUCCESS',
                payload,
            });

            return payload;
        } catch (e: any) {
            dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCreateIrelandH1ImportDeclarationWithFile: Function =
    (file: File, jobId: string, customerId: string) => async (dispatch: Function) => {
        dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_REQUEST' });

        try {
            const payload = await createIrelandH1ImportDeclarationWithFile(file, jobId, customerId);
            dispatch({
                type: 'CREATE_IRELAND_IMPORT_DECLARATION_SUCCESS',
                payload,
            });

            return payload;
        } catch (e: any) {
            dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCreateIrelandH7ImportDeclaration: Function =
    (customerId: string, declaration: IrelandH7ImportDeclarationPayload, templateId?: string) =>
    async (dispatch: Function) => {
        dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_REQUEST' });

        try {
            const payload = await createIrelandH7ImportDeclaration(customerId, declaration, templateId);
            dispatch({
                type: 'CREATE_IRELAND_IMPORT_DECLARATION_SUCCESS',
                payload,
            });

            return payload;
        } catch (e: any) {
            dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCreateIrelandH7ImportDeclarationsWithBulkUpload: Function =
    (s3Link: string, jobId: string, customerId: string) => async (dispatch: Function) => {
        dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_REQUEST' });

        try {
            const payload = await createIrelandH7ImportDeclarationsWithBulkUpload(s3Link, jobId, customerId);
            dispatch({
                type: 'CREATE_IRELAND_IMPORT_DECLARATION_SUCCESS',
                payload,
            });

            return payload;
        } catch (e: any) {
            dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCreateIrelandExportDeclaration: Function =
    (customerId: string, declaration: IrelandExportDeclarationPayload, templateId?: string) =>
    async (dispatch: Function) => {
        dispatch({ type: 'CREATE_IRELAND_EXPORT_DECLARATION_REQUEST' });

        try {
            const payload = await createIrelandExportDeclaration(customerId, declaration, templateId);
            dispatch({
                type: 'CREATE_IRELAND_EXPORT_DECLARATION_SUCCESS',
                payload,
            });

            return payload;
        } catch (e: any) {
            dispatch({ type: 'CREATE_IRELAND_EXPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCreateCdsDeclaration: Function =
    (customerId: string, declaration: CdsDeclarationPayload, templateId?: string) => async (dispatch: Function) => {
        dispatch({ type: 'CREATE_UK_DECLARATION_REQUEST' });

        try {
            const payload = await createCdsDeclaration(customerId, declaration, templateId);
            dispatch({
                type: 'CREATE_UK_DECLARATION_SUCCESS',
                payload,
            });

            return payload;
        } catch (e: any) {
            dispatch({ type: 'CREATE_UK_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCreateUkGvmsRecord: Function = (customerId: string, gvmsRecord: any) => async (dispatch: Function) => {
    dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_REQUEST' });

    try {
        const payload = await createGvmsRecord(customerId, gvmsRecord);
        dispatch({
            type: 'CREATE_IRELAND_IMPORT_DECLARATION_SUCCESS',
            payload,
        });

        return payload;
    } catch (e: any) {
        dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_ERROR', error: e?.response?.data });
    }
};

export const doCreateIePbnRecord: Function = (customerId: string, pbnRecord: any) => async (dispatch: Function) => {
    dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_REQUEST' });

    try {
        const payload = await createPbnRecord(customerId, pbnRecord);
        dispatch({
            type: 'CREATE_IRELAND_IMPORT_DECLARATION_SUCCESS',
            payload,
        });

        return payload;
    } catch (e: any) {
        dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_ERROR', error: e?.response?.data });
    }
};

export const doUpdateIrelandImportDeclaration: Function =
    (customerId: string, declarationId: string, declaration: IrelandImportDeclarationPayload) =>
    async (dispatch: Function) => {
        dispatch({ type: 'UPDATE_IRELAND_IMPORT_DECLARATION_REQUEST' });

        try {
            const payload = await updateIrelandImportDeclaration(customerId, declarationId, declaration);
            dispatch({
                type: 'UPDATE_IRELAND_IMPORT_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'UPDATE_IRELAND_IMPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doUpdateIrelandH7ImportDeclaration: Function =
    (customerId: string, declarationId: string, declaration: IrelandH7ImportDeclarationPayload) =>
    async (dispatch: Function) => {
        dispatch({ type: 'UPDATE_IRELAND_IMPORT_DECLARATION_REQUEST' });

        try {
            const payload = await updateIrelandH7ImportDeclaration(customerId, declarationId, declaration);
            dispatch({
                type: 'UPDATE_IRELAND_IMPORT_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'UPDATE_IRELAND_IMPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doUpdateIrelandExportDeclaration: Function =
    (customerId: string, declarationId: string, declaration: IrelandExportDeclarationPayload) =>
    async (dispatch: Function) => {
        dispatch({ type: 'UPDATE_IRELAND_EXPORT_DECLARATION_REQUEST' });

        try {
            const payload = await updateIrelandExportDeclaration(customerId, declarationId, declaration);
            dispatch({
                type: 'UPDATE_IRELAND_EXPORT_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'UPDATE_IRELAND_EXPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doUpdateCdsDeclaration: Function =
    (customerId: string, declarationId: string, declaration: CdsDeclarationPayload) => async (dispatch: Function) => {
        dispatch({ type: 'UPDATE_UK_EXPORT_DECLARATION_REQUEST' });

        try {
            const payload = await updateCdsDeclaration(customerId, declarationId, declaration);
            dispatch({
                type: 'UPDATE_UK_EXPORT_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'UPDATE_UK_EXPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doUpdateUkGvmsRecord: Function =
    (customerId: string, declarationId: string, gvmsRecord: UkGvmsRecord) => async (dispatch: Function) => {
        dispatch({ type: 'UPDATE_IRELAND_EXPORT_DECLARATION_REQUEST' });

        try {
            const payload = await updateGvmsRecord(customerId, declarationId, gvmsRecord);
            dispatch({
                type: 'UPDATE_IRELAND_EXPORT_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'UPDATE_IRELAND_EXPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doUpdateIePbnRecord: Function =
    (customerId: string, declarationId: string, pbnRecord: IrelandPbnRecord) => async (dispatch: Function) => {
        dispatch({ type: 'UPDATE_IRELAND_EXPORT_DECLARATION_REQUEST' });

        try {
            const payload = await updatePbnRecord(customerId, declarationId, pbnRecord);
            dispatch({
                type: 'UPDATE_IRELAND_EXPORT_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'UPDATE_IRELAND_EXPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doGetDeclaration: Function = (declarationId: string) => async (dispatch: Function) => {
    dispatch({ type: 'GET_DECLARATION_REQUEST' });

    try {
        const declaration = await getDeclaration(declarationId);

        let declarationTemplate: any = undefined;
        if (declaration?.templateId) {
            try {
                declarationTemplate = await getTemplate(declaration.templateId);
            } catch (tplErr) {}
        }

        dispatch({
            type: 'GET_DECLARATION_SUCCESS',
            declaration,
            declarationTemplate,
        });
        return declaration;
    } catch (e: any) {
        dispatch({ type: 'GET_DECLARATION_ERROR', error: e.response?.data });
        throw e;
    }
};

export const doGetDeclarationTemplate: Function = (templateId: string) => async (dispatch: Function) => {
    dispatch({ type: 'GET_TEMPLATE_REQUEST' });

    try {
        const declarationTemplate = await getTemplate(templateId);
        dispatch({
            type: 'GET_TEMPLATE_SUCCESS',
            declarationTemplate,
        });
        return declarationTemplate;
    } catch (e: any) {
        dispatch({ type: 'GET_TEMPLATE_ERROR', error: e.response?.data });
    }
};

export const doSubmitDeclaration: Function =
    (declarationId: string, emails: NotifyEmails, applySuggestedGrossMass?: boolean) => async (dispatch: Function) => {
        dispatch({ type: 'SUBMIT_DECLARATION_REQUEST' });

        try {
            const payload = await submitDeclaration(declarationId, emails, applySuggestedGrossMass);

            dispatch({
                type: 'SUBMIT_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'SUBMIT_DECLARATION_ERROR', error: e.response?.data });
            throw e;
        }
    };

export const doGetDeclarationDocuments: Function =
    (params: DeclarationDocumentsFilterFields) => async (dispatch: Function) => {
        dispatch({ type: 'GET_DECLARATION_DOCUMENTS' });

        try {
            const payload = await getDeclarationDocuments(params);
            dispatch({
                type: 'GET_DECLARATION_DOCUMENTS_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'GET_DECLARATION_DOCUMENTS_ERROR', error: e?.response?.data });
        }
    };

export const doToggleCoreTemplateStatus: Function = (declarationId: string) => async (dispatch: Function) => {
    dispatch({ type: 'TOGGLE_DECLARATION_CORE_TEMPLATE_STATUS_REQUEST' });
    try {
        const payload = await toggleCoreTemplateStatus(declarationId);
        dispatch({
            type: 'TOGGLE_DECLARATION_CORE_TEMPLATE_STATUS_SUCCESS',
            payload,
        });
        return payload;
    } catch (e: any) {
        dispatch({ type: 'TOGGLE_DECLARATION_CORE_TEMPLATE_STATUS_ERROR', error: e?.response?.data });
    }
};

export const doCreateTemporaryStorageDeclaration: Function =
    (customerId: string, declaration: IrelandTemporaryStorageDeclarationPayload) => async (dispatch: Function) => {
        dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_REQUEST' });

        try {
            const payload = await createIrelandTSDDeclaration(customerId, declaration);
            dispatch({
                type: 'CREATE_IRELAND_IMPORT_DECLARATION_SUCCESS',
                payload,
            });

            return payload;
        } catch (e: any) {
            dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCreateNctsDeclaration: Function =
    (customerId: string, declaration: NctsDeclaration) => async (dispatch: Function) => {
        dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_REQUEST' });

        try {
            const payload = await createIrelandNctsDeclaration(customerId, declaration);
            dispatch({
                type: 'CREATE_IRELAND_IMPORT_DECLARATION_SUCCESS',
                payload,
            });

            return payload;
        } catch (e: any) {
            dispatch({ type: 'CREATE_IRELAND_IMPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCreateUkNctsDeclaration: Function =
    (customerId: string, declaration: NctsDeclaration) => async (dispatch: Function) => {
        dispatch({ type: 'CREATE_UK_NCTS_DECLARATION_REQUEST' });

        try {
            const payload = await createUkNctsDeclaration(customerId, declaration);
            dispatch({
                type: 'CREATE_UK_NCTS_DECLARATION_SUCCESS',
                payload,
            });

            return payload;
        } catch (e: any) {
            dispatch({ type: 'CREATE_UK_NCTS_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doUpdateTemporaryStorageDeclaration: Function =
    (customerId: string, declarationId: string, declaration: IrelandTemporaryStorageDeclarationPayload) =>
    async (dispatch: Function) => {
        dispatch({ type: 'UPDATE_IRELAND_IMPORT_DECLARATION_REQUEST' });

        try {
            const payload = await updateIrelandTSDDeclaration(customerId, declarationId, declaration);
            dispatch({
                type: 'UPDATE_IRELAND_IMPORT_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'UPDATE_IRELAND_IMPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doUpdateNctsDeclaration: Function =
    (customerId: string, declarationId: string, declaration: NctsDeclaration) => async (dispatch: Function) => {
        dispatch({ type: 'UPDATE_IRELAND_IMPORT_DECLARATION_REQUEST' });

        try {
            const payload = await updateNctsDeclaration(customerId, declarationId, declaration);
            dispatch({
                type: 'UPDATE_IRELAND_IMPORT_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'UPDATE_IRELAND_IMPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doUpdateUkNctsDeclaration: Function =
    (customerId: string, declarationId: string, declaration: NctsDeclaration) => async (dispatch: Function) => {
        dispatch({ type: 'UPDATE_UK_NCTS_DECLARATION_REQUEST' });

        try {
            const payload = await updateUkNctsDeclaration(customerId, declarationId, declaration);
            dispatch({
                type: 'UPDATE_UK_NCTS_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'UPDATE_UK_NCTS_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCreateEntrySummaryDeclaration: Function =
    (customerId: string, declaration: IrelandEntrySummaryDeclarationPayload, templateId?: string) =>
    async (dispatch: Function) => {
        dispatch({ type: 'DO_CREATE_ENS_DECLARATION' });
        try {
            const payload = await createIrelandENSDeclaration(customerId, declaration, templateId);
            dispatch({
                type: 'DO_CREATE_ENS_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'DO_CREATE_ENS_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doUpdateEntrySummaryDeclaration: Function =
    (declarationId: string, declaration: IrelandEntrySummaryDeclarationPayload) => async (dispatch: Function) => {
        dispatch({ type: 'DO_UPDATE_ENS_DECLARATION' });
        try {
            const payload = await updateIrelandENSDeclaration(declarationId, declaration);
            dispatch({
                type: 'DO_UPDATE_ENS_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'DO_UPDATE_ENS_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCreateIcs2EnsDeclaration: Function =
    (customerId: string, declaration: Declaration) => async (dispatch: Function) => {
        dispatch({ type: 'DO_CREATE_ICS2_ENS_DECLARATION' });
        try {
            const payload = await createIcs2EnsDeclaration(customerId, declaration);
            dispatch({
                type: 'DO_CREATE_ICS2_ENS_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'DO_CREATE_ICS2_ENS_DECLARATION_ERROR', error: e?.response?.data });
            throw e;
        }
    };

export const doUpdateIcs2EnsDeclaration: Function =
    (declarationId: string, declaration: Declaration) => async (dispatch: Function) => {
        dispatch({ type: 'DO_UPDATE_ICS2_ENS_DECLARATION' });
        try {
            const payload = await updateIcs2EnsDeclaration(declarationId, declaration);
            dispatch({
                type: 'DO_UPDATE_ICS2_ENS_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'DO_UPDATE_ICS2_ENS_DECLARATION_ERROR', error: e?.response?.data });
            throw e;
        }
    };

export const doAmendIcs2EnsDeclaration: Function =
    (declarationId: string, declaration: Declaration) => async (dispatch: Function) => {
        dispatch({ type: 'DO_AMEND_ICS2_ENS_DECLARATION' });
        try {
            const payload = await amendIcs2EnsDeclaration(declarationId, declaration);
            dispatch({
                type: 'DO_AMEND_ICS2_ENS_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'DO_AMEND_ICS2_ENS_DECLARATION_ERROR', error: e?.response?.data });
            throw e;
        }
    };

export const doDuplicateDeclaration: Function =
    (declarationId: string, customerId: string, jobId: string) => async (dispatch: Function) => {
        dispatch({ type: 'DUPLICATE_DECLARATION_REQUEST' });
        try {
            const payload = await duplicateDeclaration(declarationId, customerId, jobId);
            dispatch({
                type: 'DUPLICATE_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'DUPLICATE_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doSetInputsFocused: Function = (focused: boolean) => (dispatch: Function) => {
    dispatch({
        type: 'SET_INPUT_FOCUSED',
        payload: focused,
    });
};

export const doInvalidateDeclaration: Function =
    (declarationId: string, reason: string) => async (dispatch: Function) => {
        dispatch({ type: 'INVALIDATE_DECLARATION_REQUEST' });
        try {
            const payload = await invalidateDeclaration(declarationId, reason);
            dispatch({
                type: 'INVALIDATE_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'INVALIDATE_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doInvalidateNctsDeclaration: Function =
    (declarationId: string, decision: boolean, justification: string, initiatedByCustoms: boolean) =>
    async (dispatch: Function) => {
        dispatch({ type: 'INVALIDATE_DECLARATION_REQUEST' });
        try {
            const payload = await invalidateNctsDeclaration(declarationId, decision, justification, initiatedByCustoms);
            dispatch({
                type: 'INVALIDATE_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'INVALIDATE_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doInvalidateUkNctsDeclaration: Function =
    (declarationId: string, decision: boolean, justification: string, initiatedByCustoms: boolean) =>
    async (dispatch: Function) => {
        dispatch({ type: 'INVALIDATE_DECLARATION_REQUEST' });
        try {
            const payload = await invalidateUkNctsDeclaration(
                declarationId,
                decision,
                justification,
                initiatedByCustoms
            );
            dispatch({
                type: 'INVALIDATE_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'INVALIDATE_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doInvalidateExportDeclaration: Function =
    (declarationId: string, reason: string) => async (dispatch: Function) => {
        dispatch({ type: 'INVALIDATE_EXPORT_DECLARATION_REQUEST' });
        try {
            const payload = await invalidateExportDeclaration(declarationId, reason);
            dispatch({
                type: 'INVALIDATE_EXPORT_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'INVALIDATE_EXPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doSubmitImportPresentationNotification: Function =
    (declarationId: string, type?: string, body?: {}) => async (dispatch: Function) => {
        dispatch({ type: 'SUBMIT_PRESENTATION_NOTIFICATION_REQUEST' });
        try {
            const payload = await submitImportPresentationNotification(declarationId, type, body);
            dispatch({
                type: 'SUBMIT_PRESENTATION_NOTIFICATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'SUBMIT_PRESENTATION_NOTIFICATION_ERROR', error: e?.response?.data });
        }
    };

export const doSubmitIrelandImportDocuments: Function =
    (declarationId: string, documentIds: string[]) => async (dispatch: Function) => {
        dispatch({ type: 'SUBMIT_IRELAND_IMPORT_DOCUMENTS_REQUEST' });
        try {
            const payload = await submitIrelandImportDocuments(declarationId, documentIds);
            dispatch({
                type: 'SUBMIT_IRELAND_IMPORT_DOCUMENTS_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'SUBMIT_IRELAND_IMPORT_DOCUMENTS_ERROR', error: e?.response?.data });
        }
    };

export const doClearDeclarationList: Function = () => async (dispatch: Function) => {
    dispatch({ type: 'CLEAR_DECLARATION_LIST' });
};

export const doGetDeclarationHistory: Function = (declarationId: string) => async (dispatch: Function) => {
    dispatch({ type: 'GET_DECLARATION_HISTORY_REQUEST' });
    try {
        const payload = await getDeclarationHistory(declarationId);
        dispatch({
            type: 'GET_DECLARATION_HISTORY_SUCCESS',
            payload,
        });
        return payload;
    } catch (e: any) {
        dispatch({ type: 'GET_DECLARATION_HISTORY_ERROR', error: e?.response?.data });
    }
};

export const doCreateAmendmentIrelandImportDeclaration: Function =
    (declarationId: string, detailsAmended: string) => async (dispatch: Function) => {
        dispatch({ type: 'AMENDMENT_IRELAND_IMPORT_DECLARATION_REQUEST' });
        try {
            const payload = await amendIrelandImportDeclaration(declarationId, detailsAmended);
            dispatch({
                type: 'AMENDMENT_IRELAND_IMPORT_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'AMENDMENT_IRELAND_IMPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCreateAmendmentIrelandExportDeclaration: Function =
    (declarationId: string) => async (dispatch: Function) => {
        dispatch({ type: 'AMENDMENT_IRELAND_EXPORT_DECLARATION_REQUEST' });
        try {
            const payload = await amendIrelandExportDeclaration(declarationId);
            dispatch({
                type: 'AMENDMENT_IRELAND_EXPORT_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'AMENDMENT_IRELAND_EXPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCreateAmendmentGmrRecord: Function = (declarationId: string) => async (dispatch: Function) => {
    dispatch({ type: 'AMENDMENT_IRELAND_EXPORT_DECLARATION_REQUEST' });
    try {
        const payload = await amendGmrRecord(declarationId);
        dispatch({
            type: 'AMENDMENT_IRELAND_EXPORT_DECLARATION_SUCCESS',
            payload,
        });
        return payload;
    } catch (e: any) {
        dispatch({ type: 'AMENDMENT_IRELAND_EXPORT_DECLARATION_ERROR', error: e?.response?.data });
    }
};

export const doCancelAmendmentIrelandExportDeclaration: Function =
    (declarationId: string) => async (dispatch: Function) => {
        dispatch({ type: 'CREATE_IRELAND_EXPORT_DECLARATION_REQUEST' });

        try {
            const payload = await cancelAmendmentIrelandExportDeclaration(declarationId);
            dispatch({
                type: 'CREATE_IRELAND_EXPORT_DECLARATION_SUCCESS',
                payload,
            });

            return payload;
        } catch (e: any) {
            dispatch({ type: 'CREATE_IRELAND_EXPORT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCancelAmendmentGmrRecord: Function = (declarationId: string) => async (dispatch: Function) => {
    dispatch({ type: 'CREATE_IRELAND_EXPORT_DECLARATION_REQUEST' });

    try {
        const payload = await cancelAmendmentGmrRecord(declarationId);
        dispatch({
            type: 'CREATE_IRELAND_EXPORT_DECLARATION_SUCCESS',
            payload,
        });

        return payload;
    } catch (e: any) {
        dispatch({ type: 'CREATE_IRELAND_EXPORT_DECLARATION_ERROR', error: e?.response?.data });
    }
};

export const doCreateAmendmentIrelandEntrySummaryDeclaration: Function =
    (declarationId: string, detailsAmended: string) => async (dispatch: Function) => {
        dispatch({ type: 'AMENDMENT_IRELAND_ENS_DECLARATION_REQUEST' });
        try {
            const payload = await amendIrelandEntrySummaryDeclaration(declarationId, detailsAmended);
            dispatch({
                type: 'AMENDMENT_IRELAND_ENS_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'AMENDMENT_IRELAND_ENS_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCreateElectronicTransportDocument: Function =
    (customerId: string, declaration: ElectronicTransportDocument) => async (dispatch: Function) => {
        dispatch({ type: 'DO_CREATE_ETD_DECLARATION' });
        try {
            const payload = await createIrelandEtdDeclaration(customerId, declaration);
            dispatch({
                type: 'DO_CREATE_ETD_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'DO_CREATE_ETD_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doUpdateElectronicTransportDocument: Function =
    (customerId: string, declarationId: string, declaration: ElectronicTransportDocumentPayload) =>
    async (dispatch: Function) => {
        dispatch({ type: 'DO_UPDATE_ETD_DECLARATION' });
        try {
            const payload = await updateIrelandEtdDeclaration(customerId, declarationId, declaration);
            dispatch({
                type: 'DO_UPDATE_ETD_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'DO_UPDATE_ETD_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCreateArrivalAtExitDeclaration: Function =
    (customerId: string, declaration: ArrivalAtExitDeclarationPayload) => async (dispatch: Function) => {
        dispatch({ type: 'DO_CREATE_ARRIVAL_AT_EXIT_DECLARATION' });
        try {
            const payload = await createIrelandArrivalAtExitDeclaration(customerId, declaration);
            dispatch({
                type: 'DO_CREATE_ARRIVAL_AT_EXIT_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'DO_CREATE_ARRIVAL_AT_EXIT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doUpdateArrivalAtExitDeclaration: Function =
    (customerId: string, declarationId: string, declaration: ArrivalAtExitDeclarationPayload) =>
    async (dispatch: Function) => {
        dispatch({ type: 'DO_UPDATE_ARRIVAL_AT_EXIT_DECLARATION' });
        try {
            const payload = await updateIrelandArrivalAtExitDeclaration(customerId, declarationId, declaration);
            dispatch({
                type: 'DO_UPDATE_ARRIVAL_AT_EXIT_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'DO_UPDATE_ARRIVAL_AT_EXIT_DECLARATION_ERROR', error: e?.response?.data });
        }
    };

export const doCancelCdsDeclaration: Function =
    (declarationId: string, reason: string) => async (dispatch: Function) => {
        dispatch({ type: 'CANCEL_DECLARATION_REQUEST' });
        try {
            const payload = await cancelCdsDeclaration(declarationId, reason);
            dispatch({
                type: 'CANCEL_DECLARATION_SUCCESS',
                payload,
            });
            return payload;
        } catch (e: any) {
            dispatch({ type: 'CANCEL_DECLARATION_ERROR', error: e?.response?.data });
        }
    };
